import { render, staticRenderFns } from "./instructions_title_screen.vue?vue&type=template&id=560edb1e&scoped=true&"
import script from "./instructions_title_screen.vue?vue&type=script&lang=js&"
export * from "./instructions_title_screen.vue?vue&type=script&lang=js&"
import style0 from "./instructions_title_screen.vue?vue&type=style&index=0&id=560edb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560edb1e",
  null
  
)

export default component.exports